import { z } from 'zod';
import { isValidCPF } from '../utils/formatDocuments';


z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' }
  }

  return { message: ctx.defaultError }
})

export const clientSchema = z.object({

  id: z
    .number()
    .optional(),

  nome: z
    .string()
    .min(3, "O nome deve ter no mínimo 3 caracteres")
    .refine(value => value.trim() !== "", "O nome não pode ser vazio"),

  status: z
    .number()
    .optional(),

  cpf: z
    .string()
    .regex(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, "CPF inválido")
    .refine(isValidCPF, "CPF inválido"),

  email: z
    .string()
    .email("Email inválido")
    .refine(value => value.trim() !== "", "O email não pode ser vazio"),

  telefone: z
    .string()
    .regex(/^\(\d{2}\) \d{4,5}-\d{4}$/, "Telefone inválido")
    .refine(value => value.trim() !== "", "O telefone não pode ser vazio"),
  unidade: z.object({
    id: z.union([z.number().int(), z.string()])
  })
});

export type ClientFormData = z.infer<typeof clientSchema>